export default class Context extends React.PureComponent

  constructor: (props) ->
    super(props)

    @state =
      open:             false
      msgctxt:          ''
      extractedComment: ''
      references:       []

    @toggle = @toggle.bind(this)

  componentDidUpdate: (prevProps) ->
    # When another segment is loaded, we reset state
    if @props.segment.id != prevProps.segment.id
      @setState(
        open: false
      )

  componentWillUnmount: ->
    @request.abort() if @request

  toggle: ->
    if @state.open
      @setState(open: false)
    else
      @reloadFullContext( =>
        @setState(open: true)
      )

  reloadFullContext: (callback) ->
    segmentId = @props.segment.id

    @request = http.get(path.relative("segments/#{segmentId}/context"), {}, (data) =>
      if segmentId == @props.segment.id # Make sure the result is still consistent with state
        @setState(
          msgctxt:          data.msgctxt # not necessarily the same as @props.segment.msgctxt
          extractedComment: data.extractedComment
          references:       data.references
        , callback)
    )

  render: ->
    # Note: the 'ul.list-group' structure is kept here for consistency with neighbour panels (Memory.coffee & History.coffee)
    if @props.segment.msgctxt.length # from ES, specific context based on the 3 values
      <div>
        <span className="title">
          Context
        </span>
        <ul className="list-group">
          <li className="list-group-item context">
            {@renderShortContext()}
            {@renderFullContext()}
          </li>
        </ul>
      </div>
    else
      ''

  renderShortContext: ->
    if @state.open
      hoverTitle  = "Hide full context"
      iconClasses = "context-toggle-icon fas fa-angle-up"
    else
      hoverTitle  = "Show full context"
      iconClasses = "context-toggle-icon fas fa-angle-down"

    <button className="context-short"
            title={hoverTitle}
            type="button"
            onClick={@toggle}>
        {@props.segment.msgctxt}
        <i className={iconClasses} />
    </button>

  renderFullContext: ->
    if @state.open
      <ul className="context-full list-unstyled">
        {@renderMsgctxt()}
        {@renderExtractedComment()}
        {@renderReferences()}
      </ul>

  renderMsgctxt: ->
    # Note: we opt for a generic "Context" heading here...
    #
    # ...but the value of the 'msgctxt' attribute on segments varies depending on the segment kind:
    # 1) yaml segments (key-type API segments)
    #   - it is the localization key (ex: on Rails & Laravel projects)
    # 2) content segments (key-type API segments)
    #   - it is a context like "Project-10-description"
    # 3) gettext segments (source-type API segments)
    #   - it can be a real "context" written by developers (gettext syntax)
    #   - it can be an explicit ID (key) for Lingui projects (when extracted comment contains "js-lingui-explicit-id")
    #   - it can be mixed content for Angular projects?
    if @state.msgctxt
      <li>
        <strong>
          Context
        </strong>
        <span>
          {@state.msgctxt}
        </span>
      </li>

  renderExtractedComment: ->
    if @state.extractedComment
      <li>
        <strong>
          Extracted comment
        </strong>
        <span>
          {@state.extractedComment}
        </span>
      </li>

  renderReferences: ->
    if @state.references.length
      <li>
        <strong>
          References
        </strong>
        {@state.references.map(@renderReferenceSpan)}
      </li>

  renderReferenceSpan: (reference, index) ->
    <span key={index}>
      {reference}
    </span>
